module.exports = __webpack_public_path__ + "assets/content-min.ea3c4811973bcac4a7a7a7989ddb7898.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Catlish/content-min.jpg
 ** module id = 400
 ** module chunks = 0
 **/